<template>
    <v-dialog
        v-model="showPayrollReportsDialog"
        fullscreen
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-toolbar
                dark
                color="grey darken-4"
            >
                <v-btn
                    class="mx-auto"
                    icon
                    dark
                    @click="showPayrollReportsDialog = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="mx-auto">Payroll Reports</v-toolbar-title>

                <v-spacer></v-spacer>

            </v-toolbar>
            <v-container class="">
                <v-snackbar
                    v-model="snackbarFilter"
                    :color="snackbarFilterColor"
                    text
                    :timeout="3000"
                    top
                    rounded="pill"
                >
                    {{ snackbarFilterText }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                            :color="snackbarFilterColor"
                            text
                            v-bind="attrs"
                            @click="snackbarFilter = false"
                            icon
                        >
                            <v-icon
                                dark
                            >
                                mdi-close-circle-outline
                            </v-icon>
                        </v-btn>
                    </template>
                </v-snackbar>
                <v-row>
                    <v-col
                        cols="12"
                        md="3"
                        sm="4"
                    >
                        <v-menu
                            ref="startDateFilterMenu"
                            v-model="startDateFilterMenu"
                            :close-on-content-click="false"
                            :return-value.sync="startDateFilter"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="startDateFilter"
                                    label="Start"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="startDateFilter"
                                no-title
                                scrollable
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="startDateFilterMenu = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.startDateFilterMenu.save(startDateFilter)"
                                >
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        cols="12"
                        md="3"
                        sm="4"
                    >
                        <v-menu
                            ref="endDateFilterMenu"
                            v-model="endDateFilterMenu"
                            :close-on-content-click="false"
                            :return-value.sync="endDateFilter"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="endDateFilter"
                                    label="End"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="endDateFilter"
                                no-title
                                scrollable
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="endDateFilterMenu = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.endDateFilterMenu.save(endDateFilter)"
                                >
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        md="3"
                        sm="4"
                    >
                        <v-select
                            :items="selectUserStatusFilter"
                            label="User"
                            item-value="name"
                            item-text="name"
                            v-model="selectedUserStatus"
                            @change="getAllStaff"
                            clearable
                        >
                            <template v-slot:item="{ on, item }">
                                <v-list-item 
                                    v-on="on" 
                                    :disabled="item.isDisabled"
                                >
                                    {{ item.name }}
                                </v-list-item>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        md="3"
                        sm="4"
                    >
                        <v-btn
                            class="my-4"
                            color="primary"
                            dark
                            elevation="1"
                            @click="filterPayrollReports"
                            :loading="filterLoader"
                            :disabled="filterLoader"
                        >
                            Apply
                            <v-icon>mdi-filter</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col
                        cols="12"
                        md="3"
                        sm="4"
                        v-show="isShowClearFilter"
                    >
                        <v-btn
                            rounded
                            small
                            color="grey lighten-4"
                            class="my-2"
                            @click="clearFilter"
                            :loading="filterLoader"
                            :disabled="filterLoader"
                        >
                            Clear Filters
                            <v-icon
                                right
                                dark
                            >
                                mdi-close-circle-outline
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :headers="headers"
                            :items="staffs"
                            class="elevation-1"
                            :options.sync="options"
                            :server-items-length="totalStaffs"
                            :loading="payrollReportsTableLoader"
                            loading-text="Loading . . . "
                        >
                            <template v-slot:item.view="{ item }">
                                <div>
                                    <v-icon class="" @click="viewUserPayrollReport(item)">
                                        mdi-eye
                                    </v-icon>
                                </div>
                            </template>
                        </v-data-table>
                        <UserPayrollReport 
                            v-if="isOpenUserPayrollReport"
                            v-model="isOpenUserPayrollReport" 
                            :selectedUserPayrollReport="selectedUserPayrollReport"
                        >
                        </UserPayrollReport>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import moment from "moment";

import { mapGetters } from "vuex";
import { setUserTz } from "../../../../utils/timezone";

import UserPayrollReport from "./UserPayrollReport.vue"

const url = require("../../../client_config/config").url;

export default {
    components: {UserPayrollReport},

    props: {
        value: Boolean
    },
  
    data () {
        return {
            state: localStorage.getItem('userState'),
            headers: [
                {
                    text: 'Staff',
                    align: 'start',
                    sortable: false,
                    value: 'Name',
                },
                { text: 'Start', value: 'Date', },
                { text: 'End', value: 'TerminationDate',},
                { text: 'Status', value: 'Status', align: 'center', sortable: false },
                { text: 'View', value: 'view', align: 'center', sortable: false,},
            ],
            staffs: [],
            payrollReportsTableLoader: false,

            isOpenUserPayrollReport: false,
            selectedUserPayrollReport: {},

            options: {},
            totalStaffs: 0,

            startDateFilterMenu: false,
            endDateFilterMenu: false,
            startDateFilter: "",
            endDateFilter: "",
            selectedUserStatus: "",
            selectUserStatusFilter: [
                {name: "Active", isDisabled: false}, 
                {name: "Terminated", isDisabled: false}, 
                {name: "Inactive", isDisabled: true}, 
                {name: "New", isDisabled: true}
            ],

            isShowClearFilter: false,
            filterLoader: false,

            snackbarFilter: false,
            snackbarFilterText: "",
            snackbarFilterColor: "",
        }
    },

    async created() {
        // this.getAllStaff();
    },

    watch: {
        options: {
            handler () {
                this.getAllStaff()
            },
            deep: true,
        },

        selectedUserStatus (val) {
            val != "" ? this.isShowClearFilter = true : this.isShowClearFilter
        }
    },

    computed: {
        ...mapGetters({
            getUserTimezone: "timezones/getUserTimezone",
            getDefaultTz: "timezones/getDefaultTz",
        }),

        userTimezone() {
            const data = {
                userTimezone: this.getUserTimezone,
                defaultTz: this.getDefaultTz,
            };
            return setUserTz(data);
        },

        showPayrollReportsDialog: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        }
    },

    methods: {
        getAllStaff() {
            this.payrollReportsTableLoader = true;

            const {sortBy, sortDesc, page, itemsPerPage} = this.options;

            let req_body = {
                state: this.state,
                page,
                itemsPerPage,
                sortBy,
                sortDesc,
                userStatus: this.selectedUserStatus,
                startDateFilter: this.startDateFilter,
                endDateFilter: this.endDateFilter,
                Timezone: this.userTimezone,
            }
            
            axios.post(`${url}/customCompanyPayrolls/getAll`, req_body).then(res => {
                this.staffs = res.data.staffs;
                this.totalStaffs = res.data.totalStaffs;
                
                res.data.staffs.forEach(staff => {
                    if (staff.Date == "Invalid date") staff.Date = null;

                    if (staff.Date) staff.Date = moment(new Date(staff.Date)).format("YYYY-MM-DD");
                    if (staff.TerminationDate) staff.TerminationDate = moment(new Date(staff.TerminationDate)).format("YYYY-MM-DD");
                })

                // this.staffs = this.staffs.filter(staff => (staff.Date !== "Invalid date"))
                // this.staffs = this.staffs.filter(staff => staff.Date !== "1969-12-31")
                
                // sort by <???>
                switch (sortBy[0]) {
                    case "Date": {
                        if (sortDesc[0]) {
                            this.staffs.sort(function(a, b) {
                                return new Date(b.Date) - new Date(a.Date)
                            });
                        } else if (!sortDesc[0]) {
                            this.staffs.sort(function(a, b) {
                                return new Date(a.Date) - new Date(b.Date)
                            });
                        }
                        break;
                    }
                    case "TerminationDate": {
                        if (sortDesc[0]) {
                            this.staffs.sort(function(a, b) {
                                return new Date(b.TerminationDate) - new Date(a.TerminationDate)
                            });
                        } else if (!sortDesc[0]) {
                            this.staffs.sort(function(a, b) {
                                return new Date(a.TerminationDate) - new Date(b.TerminationDate)
                            });
                        }
                        break;
                    }
                    // default: {
                        
                    //     break;
                    // }
                }
            }).finally(() => {
                this.payrollReportsTableLoader = false;

                this.filterLoader = false;
            });
        },

        viewUserPayrollReport (item) {
            this.isOpenUserPayrollReport = true;
            this.selectedUserPayrollReport = item
            // console.log(this.selectedUserPayrollReport);
        },

        filterPayrollReports () {
            this.filterLoader = true;

            if (this.startDateFilter != "" || this.endDateFilter != "") {
                let startDateFilter = moment(this.startDateFilter).format("YYYY-MM-DD");
                let endDateFilter = moment(this.endDateFilter).format("YYYY-MM-DD");
                
                if (startDateFilter == "Invalid date" && endDateFilter != "Invalid date") {
                    this.snackbarFilterText = "Please fill-in the Start date."
                    this.snackbarFilterColor = "error"
                    this.snackbarFilter = true;

                    this.filterLoader = false;
                } else if (startDateFilter != "Invalid date" && endDateFilter == "Invalid date") {
                    this.snackbarFilterText = "Please fill-in the End date."
                    this.snackbarFilterColor = "error"
                    this.snackbarFilter = true;

                    this.filterLoader = false;
                } else {
                    if (moment(endDateFilter).isAfter(startDateFilter)) {
                        this.getAllStaff()

                        this.isShowClearFilter = true;
                    } else {
                        this.snackbarFilterText = "End date must be after Start date."
                        this.snackbarFilterColor = "error"
                        this.snackbarFilter = true;

                        this.filterLoader = false;
                    }
                }
            } else {
                this.filterLoader = false;
            }
        },

        clearFilter () {
            this.filterLoader = true;
            this.startDateFilter = "";
            this.endDateFilter = "";
            this.selectedUserStatus = "";

            this.getAllStaff()

            this.isShowClearFilter = false;
        },
    }
}
</script>